document.addEventListener("DOMContentLoaded", () => {
    let autoCloseTimer;

    function handleClickEvents() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
            $(".virtual-try-on-snippet").on("click", function () {
                let url = $(this).data('href');
                $(this).addClass('open');

                clearTimeout(autoCloseTimer);

                autoCloseTimer = setTimeout(() => {
                    $(this).removeClass('open');
                    $(this).attr('href', 'javascript:void(0)');
                }, 8000);

                setTimeout(() => {
                    $(this).attr('href', url);
                }, 500);
            });

            $(window).on("click", function (e) {
                const snippet = $(".virtual-try-on-snippet");
                if (snippet.hasClass("open")) {
                    if (!snippet.is(e.target) && snippet.has(e.target).length === 0) {
                        snippet.removeClass("open");
                        snippet.attr("href", "javascript:void(0)");

                        // Clear the auto-close timer when manually closed
                        clearTimeout(autoCloseTimer);
                    }
                }
            });
        } else {
            $(".virtual-try-on-snippet").off("click");
            $(window).off("click");
        }
    }

    // Run on initial load
    handleClickEvents();

    $(window).on("resize", handleClickEvents);
});
